import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardTitle,} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    deleteMsg,
    error,
    LIST,
    NO,
    warning,
    YES
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {ButtonTableDelete, ButtonTableEdit} from "../../../components/buttons/buttonsActions";
import {typeUdnService} from "../../../jwt/_services";
import {showToastCustom} from "../../../components/toast/customToast";
import {showLoader} from "../../../components/loader/loader";

export default function TypeUdnList(props) {


    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        refreshDataList(page, currentIndex, sizePerPage);
    }, []);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage);
    };

    const refreshDataList = (page, currentIndex, sizePerPage) => {
        setLoading(true);
        typeUdnService.getPagedList(currentIndex, sizePerPage)
            .then(result => {
                if (result){
                    setListItems(result.data);
                    setTotalSize(result.total);
                    setCurrentIndex(currentIndex);
                    setPage(page);
                    setSizePerPage(sizePerPage);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(0);
                    setPage(1);
                    setSizePerPage(10);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(0);
                setPage(1);
                setSizePerPage(10);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        typeUdnService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);
                setListItems(listItems.filter(register => register.id !== data.id));
                showToastCustom(warning, deleteMsg, true);
            });
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.beginEdit(itemToEdit);
    }

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
                <ButtonTableEdit onClick={() => editItem(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'name',
        text: 'Nombre',
        headerStyle: {width: '400px'},
        sort: true
    }, {
        dataField: 'code',
        headerStyle: {width: '30px'},
        text: 'Codigo',
    }, {
        dataField: 'status',
        text: 'Activo',
        headerStyle: {width: '50px'},
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '80px'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                </CardTitle>
                <CardBody className="">
                    {loading ? showLoader() :
                            <BootstrapTable
                                striped hover
                                tableHeaderClass='mb-0'
                                remote
                                keyField="id"
                                data={listItems}
                                columns={columns}
                                pagination={paginationFactory({page, sizePerPage, totalSize})}
                                onTableChange={handleTableChange}
                            />
                    }
                </CardBody>
            </Card>
        </div>
    )
}